module.exports = __webpack_public_path__ + "static/screenie_search_3-2e5e547d665d8ce571634cc8758b9d34.jpg";